import {
  MenuItem,
  MenuItemProps,
  Tooltip,
  useDisclosure,
} from "@chakra-ui/react";
import { OptionalKeys } from "utils/typescriptUtilis";
import ConfirmModalMutation, {
  ConfirmModalMutationProps,
} from "./ConfirmModalMutation";

export type Props<TData = unknown, TVariables = unknown> = Omit<
  OptionalKeys<ConfirmModalMutationProps<TData, TVariables>, "label">,
  "isOpen" | "onClose"
> & {
  menuItemProps?: Partial<Omit<MenuItemProps, "onClick">>;
  disabledTooltip?: React.ReactNode;
};

export default function ConfirmMenuItem<TData, TVariables>({
  menuItemProps,
  disabledTooltip,
  label = "Delete",
  ...rest
}: Props<TData, TVariables>) {
  const { isOpen, onClose, onOpen } = useDisclosure();

  return (
    <>
      <Tooltip
        label={
          menuItemProps?.isDisabled && disabledTooltip ? disabledTooltip : label
        }
        placement="auto-end"
        hasArrow
        isDisabled={!menuItemProps?.isDisabled || !disabledTooltip}
      >
        <MenuItem onClick={onOpen} {...menuItemProps}>
          {label}
        </MenuItem>
      </Tooltip>

      <ConfirmModalMutation {...{ isOpen, label, onClose }} {...rest} />
    </>
  );
}
